module.exports = __webpack_public_path__ + "static/media/rpt-screen-card.b0987d58.jpg";